import React from 'react';
import { SxProps, Typography, useTheme } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import {
  BorderRadius,
  ColorPalette,
  TypographyFamily,
} from '../../../styles/constants';
import { MyCoolGradient } from './myCoolGradient';
import { LoadingButton } from '@mui/lab';

interface Props {
  handleClick(): void;
  label: string;
  sx?: SxProps;
  isDisabled?: boolean;
  hideIcon?: boolean;
  isLoading?: boolean;
}

export function AppButtonOutlined({
  handleClick,
  sx,
  label,
  isDisabled = false,
  hideIcon = false,
  isLoading = false,
}: Props): JSX.Element {
  const theme = useTheme();

  return (
    <LoadingButton
      onClick={handleClick}
      sx={{
        ...sx,
        py: '6px',
        fontFamily: TypographyFamily.NEXA,
        boxShadow: 'none',
        border: '2px solid transparent',
        background: ColorPalette.GRADIENT_OUTLINED_BUTTON,
        borderRadius: BorderRadius.SMALL,
        ...(isDisabled && { background: ColorPalette.DARK_GRAY }),

        '&:hover': {
          background: ColorPalette.GRADIENT_OUTLINED_HOVER,
          boxShadow: 'none',
          border: '2px solid transparent',
        },
      }}
      loading={isLoading}
      variant="outlined"
      disabled={isDisabled}
    >
      <MyCoolGradient />
      {!hideIcon && (
        <FileDownloadOutlinedIcon
          sx={{
            mr: 1,
            ...(isDisabled
              ? { color: ColorPalette.WHITE }
              : {
                  fill: `url(#my-cool-gradient) ${theme.palette.primary.main}`,
                }),
          }}
        />
      )}
      <Typography
        sx={{
          mt: 0.5,
          fontFamily: TypographyFamily.NEXA,
          fontSize: '16px',
          fontWeight: 800,
          background: isDisabled
            ? ColorPalette.WHITE
            : ColorPalette.GRADIENT_TWO,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          lineHeight: '18px',
          visibility: isLoading ? 'hidden' : 'visible',
          textAlign: 'center',
        }}
      >
        {label}
      </Typography>
    </LoadingButton>
  );
}
